import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

export const SERVICES_UNAVAILABLE_PATH = 'services-unavailable';

@Component({
    selector: 'sphere-services-unavailable',
    templateUrl: './services-unavailable.component.html',
    styleUrls: ['./services-unavailable.component.scss'],
    imports: []
})
export class ServicesUnavailableComponent implements OnInit {
    private router = inject(Router);

    public message: string;

    constructor() {
        const router = this.router;

        const navigation = router.currentNavigation();
        if (navigation && navigation.extras && navigation.extras.state && navigation.extras.state.error) {
            this.message = navigation.extras.state.error;
        }
    }

    ngOnInit() {}
}
